import ProjectService from '@/services/project';

export default {
  state: {
    adhocId: 419,
    awsId: 12,
    sections: {},
    isTouchscreen: false
  },
  getters: {
    adhocId: state => state.adhocId,
    awsId: state => state.awsId,
    isTouchscreen: state => state.isTouchscreen
  },
  mutations: {
    parseSectionData(state, payload) {
      payload.forEach((section) => {
        state.sections[section.section_name] = section;
      });
    }
  },
  actions: {
    async FETCH_SECTIONS({ commit, dispatch, rootState }) {
      const res = await ProjectService.fetchSectionData(rootState.project.adhocId);
      commit('parseSectionData', Object.values(res.data.section));
      dispatch('PARSE_VIEWS', Object.values(res.data.section));
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/Project.js